export const environment = {
  production: true,
  demo: false,
  backendUrl: 'https://modular-dev.isomasters.com/',
  environment: 'test',
  color: '#FF0000',
  applicationInsightsInstrumentationKey: '210dfabd-952b-4069-b43f-8245a319690c',
  webshopUrl: 'https://webshop-test.isomasters.com',
  frontendUrl: 'https://modular-dev.isomasters.com',
  googleAnalyticsTrackingCode: 'G-MZ7CFJ7K7D',
};
